<div class="modal-header bg-info">
  <div class="container-fluid">
    <div class="col-12">
      <h4 class="modal-title text-white">{{title}}</h4>
      <button
        (click)="emitClose()"
        aria-label="Close"
        class="close pull-right"
        type="button"
      >
        <span aria-hidden="true">
          x
        </span>
      </button>
    </div>
    <div class="col-12 row">
      <div class="col-4">
        <app-search
          [data]="getDataCopy()"
          [type]="searchType"
          (searchResult)="searchResponse($event)"
        ></app-search>
      </div>
      <div class="col-8">
        <pagination-controls
          (pageChange)="pageChanged($event)"
          (pageBoundsCorrection)="pageChanged($event)"
          maxSize="8"
          directionLinks="true"
          autoHide="true"
          responsive="true"
          previousLabel="Previous"
          nextLabel="Next"
          screenReaderPaginationLabel="Pagination"
          screenReaderPageLabel="page"
          screenReaderCurrentLabel="You're on page"
        >
        </pagination-controls>
      </div>
    </div>
  </div>
</div>
<div class="modal-body">
  <div *ngIf="!data || !data.length" style="text-align: center; font-size: 1.4em;" class="text-info">
    There is no data provided
  </div>
  <div *ngIf="data && data.length">
    <div *ngIf="dataKind === 100">
      <div class="card-body mt-0 pt-1 pb-2 mx-0 px-2">
        <div class="iteration">
          <div
            class="item-container mt-1 pt-0"
            *ngFor="
          let dta of data
            | paginate
              : {
                  itemsPerPage: pageSize,
                  currentPage: p,
                  totalItems: total
                };
          let i = index
        "
          >
            <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
              <div class="list-card-body card-body my-0 py-0 mx-2">
                <div class="row my-0 py-0 px-4">
                  <app-client-report
                    [itm]="dta"
                    (click)="emitSelection(dta)"
                  ></app-client-report>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div *ngIf="dataKind === 200">
      <div
        style="border-radius: 1em; border: 1px solid lightskyblue; background-color: lightskyblue;"
        class="p-2 mb-1"
        *ngFor="
        let dta of data
        | paginate
        : {
        itemsPerPage: pageSize,
        currentPage: p,
        totalItems: total
        };
        let i = index
      "
        (click)="emitSelection(dta)"
      >
        <div class="report row">
          <div class="field col-4">
            <div class="row">
              <div class="col-5 d-flex justify-content-start">
                <span class="">Station ID: </span>
              </div>
              <div class="col-7 d-flex justify-content-start font-weight-bold">
                <span class="itemCreated">
                  {{ dta.stationId }}
                </span>
              </div>
            </div>
          </div>
          <div class="field-1 col-8">
            <div class="row">
              <div class="col-4 d-flex justify-content-start">
                <span class="">Station Name: </span>
              </div>
              <div class="col-8 d-flex justify-content-start font-weight-bold mx-0 px-0">
                <span class="itemCreated">
                  {{ dta.stationName }}
                </span>
              </div>
            </div>
          </div>
          <div class="field-2 col-4">
            <div class="row">
              <div class="col-5 d-flex justify-content-start">
                <span class="">Location ID: </span>
              </div>
              <div class="col-7 d-flex justify-content-start font-weight-bold">
                <span class="itemCreated">
                  {{ dta.theStationLocationId }}
                </span>
              </div>
            </div>
          </div>
          <div class="field-3 col-8">
            <div class="row">
              <div class="col-5 d-flex justify-content-start">
                <span class="">Aproval Status: </span>
              </div>
              <div class="col-7 d-flex justify-content-start font-weight-bold">
                <span class="itemCreated">
                  APPROVED
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
<div class="modal-footer">   
  <button
    (click)="emitClose()"
    class="btn btn-info col-3 col-xl-2 pull-right"
    type="button"
    >
      close
  </button>
</div>
